import { render, staticRenderFns } from "./StudentRoster.vue?vue&type=template&id=f8fa947a&"
import script from "./StudentRoster.vue?vue&type=script&lang=js&"
export * from "./StudentRoster.vue?vue&type=script&lang=js&"
import style0 from "./StudentRoster.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports